import type { GroupKey, HitlItem } from '../types';
import { isPlainClick } from '@/components/plainClick';

function Row({ item, selected, onSelect }: { item: HitlItem; selected: boolean; onSelect: (id: string) => void }) {
  return (
    <a href={`/human-in-the-loop/${item.id}`} className={`hl-row${selected ? ' sel' : ''}`} aria-current={selected ? 'page' : undefined} onClick={(e) => { if (!isPlainClick(e)) return; e.preventDefault(); onSelect(item.id); }}>
      <div className="hl-rtop">
        <span className="hl-kind">{item.kindLabel}</span>
        {item.deadlineWarn ? <span className="hl-badge warn">{item.deadlineText}</span> : <span className="hl-rmeta">{item.deadlineText}</span>}
      </div>
      <div className="hl-rtitle">{item.title}</div>
      <div className="hl-rmeta">{item.listContext ?? item.metaLine.split(' · ')[0]}</div>
    </a>
  );
}

export function List({
  groups,
  doneCount,
  selectedId,
  onSelect,
  onOpenDone,
}: {
  groups: { key: GroupKey; label: string; items: HitlItem[] }[];
  doneCount: number;
  selectedId?: string;
  onSelect: (id: string) => void;
  /** Open the full Done history (00-ds-09 §2, D148, lists at scale). */
  onOpenDone: () => void;
}) {
  return (
    <div className="hl-list">
      {groups.map((g) => (
        <div key={g.key}>
          <p className={`hl-grp${g.label.toLowerCase().startsWith('today') ? ' today' : ''}`}>
            {g.label} · {g.items.length}
          </p>
          {g.items.map((it) => <Row key={it.id} item={it} selected={it.id === selectedId} onSelect={onSelect} />)}
        </div>
      ))}
      <div className="hl-done-line">
        <button type="button" className="hl-src" onClick={onOpenDone}>
          Done in the last 30 days: {doneCount.toLocaleString()} · Show
        </button>
      </div>
    </div>
  );
}
